module.exports = __webpack_public_path__ + "static/media/notification.f54d10fc.svg";